module.exports = __webpack_public_path__ + "fonts/6a2c42b22eaf16d7cc342695ebd4c458.svg";